class RichTextWidget extends BaseWidget<RichTextResultVM, RichTextConfig> {
    override widgetType = WidgetType.RichText;
    
    constructor(container: any, tab: WorkbookTab, $reportContent, dashboardWidget: DashboardWidget) {
        super(container, tab, $reportContent, dashboardWidget);
        this.disableDrilldown = true;
    }

    setConfig(config) {
        this.itemConfig = new RichTextConfig(config);
    }

    setResult(result) {
        this.result = new RichTextResultVM(result);
    }

    setupSettings() {
        this.createSettingItem(this.itemConfig.htmlText, "htmlText", UpdateSettingMode.Reload);
    }

    repaint() {

    }

    runSetup() {

    }

    setup() {

    }

    convertHtml(value: string): { success: boolean, value: string } {
        let returnValue = true;
        let html = value;
        let submitObject = this.tabOrWidget.getBaseSubmitObject() as any;
        submitObject.htmlContent = value;

        let o = {
            url: urlConfigs.dashboard + "ConvertRichTextHtml",
            data: submitObject,
            dataType: "json",
            async: false,
        } as RequestServerParams;
        o.successFunction = function (data) {
            html = data.html;
        }.bind(this);
        o.failureFunction = function (textStatus, errorThrown, errorItem: IError) {
            returnValue = false;
            errorItem.userMessage = `Failed to convert rich text to html`;
            irGlobal.defaultErrorFunction(errorItem.userMessage, textStatus, errorThrown);
        };

        irGlobal.requestServer(o);

        return { success: returnValue, value: html };
    }
}